export class LenderMapper {
	acuityId?: string;
	acuityName?: string;
	insideMapsOrgId?: string;
	scopeId?: string;
	scopeName?: string;
	cmpAcuityId?: string;
	cmpAcuityName?: string;
	id?: string;

	constructor(){
		this.acuityId = "";
		this.acuityName = "";
		this.insideMapsOrgId = "";
		this.scopeId = "";
		this.scopeName = "";
		this.cmpAcuityId = "";
		this.cmpAcuityName = "";
	}
}

/**
 * Model for Lender
 *
 */
export class LenderModel {
	defaultAcuityBranchId?: string;
	defaultAcuityBranchIdWhenClass?: string;
	defaultAcuityBranchName?: string;
	defaultAcuityBranchNameWhenClass?: string;
	mappers?: any;
}

export class AcuityLenderBranch {
	id?: string;
	title?: string;
}

export class Lender {
	id?: string;
	title?: string;
}

export const DELETE_MAPPER_LENDER = 'DELETE_MAPPER_LENDER';
